<template>
  <div class="LibraryOfGoods">
    <div class="tabs_item">
      <template v-for="(item, index) in TabsData">
        <el-button
          :type="tabsIdx == index ? 'primary' : 'text'"
          :key="index"
          size="small"
          round
          @click="tabsIdx = index"
        >{{ item }}</el-button>
      </template>
    </div>
    <div class="goods" v-if="tabsIdx == 0">
      <div class="headline">商品库</div>
      <div class="screen_operation">
        <div class="lft">
          <el-form :inline="true" :model="formInline" class="demo-form-inline" size="small">
            <el-form-item label="上下架状态">
              <el-select v-model="formInline.region" placeholder="上下架状态" class="min_max">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="库存状态">
              <el-select v-model="formInline.region" placeholder="库存状态" class="min_max">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="商品分类">
              <el-select v-model="formInline.region" placeholder="商品分类" class="min_max">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="售卖限制">
              <el-select v-model="formInline.region" placeholder="售卖限制" class="min_max">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="后台分类">
              <el-select v-model="formInline.region" placeholder="后台分类" class="min_max">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label>
              <el-input v-model="formInline.user" placeholder="请输入商品名称" class="min_max mgn-lft"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="rgt"></div>
      </div>
      <div class="goods_operation">
        <div class="lft">
          <el-radio-group v-model="radio3" size="small">
            <el-radio-button label="1">估清</el-radio-button>
            <el-radio-button label="2">无限</el-radio-button>
            <el-radio-button label="3">修改库存</el-radio-button>
            <el-radio-button label="4">上架</el-radio-button>
            <el-radio-button label="5">下架</el-radio-button>
            <el-radio-button label="6">删除</el-radio-button>
            <el-radio-button label="7">
              <el-dropdown>
                <span class="el-dropdown-link">
                  更多
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>黄金糕</el-dropdown-item>
                  <el-dropdown-item>狮子头</el-dropdown-item>
                  <el-dropdown-item>螺蛳粉</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-radio-button>
          </el-radio-group>
        </div>
        <div class="rgt">
          <router-link to="createshopFood" style="margin-right:10px;">
            <el-button size="small" type="primary">新建商品</el-button>
          </router-link>
          <el-button size="small" type="primary">新建套餐</el-button>
          <el-button size="small" plain>批量上传</el-button>
          <el-button size="small" plain>批量下载</el-button>
        </div>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="单品" name="first">
          <div class="tables">
            <template>
              <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="date" label="已选择0道商品 min-width="180"></el-table-column>
                <el-table-column prop="name" label="价格" min-width="180"></el-table-column>
                <el-table-column prop="address" label="库存" min-width="180"></el-table-column>
                <el-table-column prop="name" label="后台分类" min-width="180"></el-table-column>
                <el-table-column prop="address" label="商品分类" min-width="180"></el-table-column>
                <el-table-column prop="address" label="操作" min-width="180"></el-table-column>
              </el-table>
            </template>
          </div>
        </el-tab-pane>
        <el-tab-pane label="套餐" name="second">配置管理</el-tab-pane>
      </el-tabs>
    </div>

    <template v-if="tabsIdx == 1">
      <div class="btn_header">
        <el-button size="small" type="primary" @click="dialogFormVisible = true">新建备注</el-button>
      </div>
      <div class="tables">
        <template>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="date" label="备注名" min-width="180"></el-table-column>
            <el-table-column prop="name" label="备注选项" min-width="180"></el-table-column>
            <el-table-column prop="address" label="选择属性" min-width="180"></el-table-column>
            <el-table-column prop="address" label="操作" min-width="180"></el-table-column>
          </el-table>
        </template>
      </div>
      <el-dialog title="新建备注" :visible.sync="dialogFormVisible">
        <el-row :gutter="15">
          <el-col :span="4">
            <div class="grid-content align_right">备注姓名</div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content">
              <el-input v-model="input" placeholder="请输入内容" size="small"></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="4">
            <div class="grid-content align_right">选项设置</div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content">
              <el-checkbox-group v-model="checkList">
                <el-checkbox label="仅在套餐中售卖"></el-checkbox>
                <el-checkbox label="顾客可选多项备注"></el-checkbox>
              </el-checkbox-group>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="4">
            <div class="grid-content align_right">备注姓名</div>
          </el-col>
          <el-col :span="18">
            <div class="grid-content">
              <template>
                <el-table :data="tableDatas" style="width: 100%" border>
                  <el-table-column label="备注名" min-width="100">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.date" placeholder="请输入内容" size="small"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="加价" min-width="100">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.name" placeholder="请输入内容" size="small"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="售卖状态" min-width="100"></el-table-column>
                  <el-table-column prop="name" label="操作" min-width="100">
                    <template slot-scope="scope">
                      <el-button size="small" type="text">上移</el-button>
                      <el-button size="small" type="text">下移</el-button>
                      <el-button size="small" type="text">移除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="3" :offset="4">
            <div class="grid-content">
              <el-button size="small" type="text">添加备注项</el-button>
            </div>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
        </div>
      </el-dialog>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableDatas: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        }
      ],
      checkList: [],
      dialogFormVisible: false,
      radio3: "1",
      formInline: {
        user: "",
        region: ""
      },
      TabsData: ["商品库", "备注管理", "打包盒设置"],
      tabsIdx: 0,
      activeName: "first",
      tableData: [],
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: ""
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.LibraryOfGoods {
  width: 100%;
  padding: 15px 25px;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
}
.goods {
  padding-left: 10px;
  .headline {
    margin: 20px 0px;
    font-size: 16px;
    font-weight: 600;
  }
  .screen_operation {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .lft {
      .min_max {
        min-width: 100px;
        max-width: 155px;
      }
      .mgn-lft {
        margin-left: 80px;
      }
    }
  }
  .goods_operation {
    padding-right: 60px;
    margin-top: 20px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .lft {
    }
    .rgt {
    }
  }
}
.btn_header {
  margin: 20px 0;
}
.tables {
  border: 1px solid rgba(235, 238, 245, 1);
}
.el-row {
  margin-bottom: 15px;
  .grid-content {
    min-height: 32px;
    line-height: 32px;
  }
  .align_right {
    text-align: right;
  }
}
</style>

<style lang="scss">
.LibraryOfGoods {
  .cell {
    text-align: center;
  }
  .el-radio-button--small .el-radio-button__inner {
    padding: 9px 40px;
  }
  .el-tabs__nav-wrap::after {
    background-color: transparent;
  }
}
</style>
